export class FundsToExploreState {
	public fundsToExplore: { [portfolioId: string]: any[] } = {};
}
